module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Profile Page"), _c('small', [_vm._v("It's all start from here "), _c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Profile")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('div', {
    staticClass: "movie-card"
  }, [_c('div', {
    staticClass: "container-movie"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "cover-profile",
    attrs: {
      "src": "http://api.randomuser.me/portraits/men/32.jpg",
      "alt": "cover"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "details-profile"
  }, [_c('div', {
    staticClass: "title1"
  }, [_vm._v("Dave Mattew "), _c('span', [_vm._v("Web Designer")])]), _vm._v(" "), _c('div', {
    staticClass: "title2"
  }, [_vm._v("The Battle of the Five Armies")])])]), _vm._v(" "), _c('div', {
    staticClass: "description-profile"
  }, [_c('div', {
    staticClass: "column1 text-center"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("html5")]), _vm._v(" "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("php")]), _vm._v(" "), _c('span', {
    staticClass: "tag"
  }, [_vm._v("javascript")]), _c('span', {
    staticClass: "tag"
  }, [_vm._v("css")]), _c('span', {
    staticClass: "tag"
  }, [_vm._v("photoshop")])]), _vm._v(" "), _c('div', {
    staticClass: "column2"
  }, [_c('p', [_vm._v("Bilbo Baggins is swept into a quest to reclaim the lost Dwarf Kingdom of Erebor from the fearsome dragon Smaug. Approached out of the blue by the wizard Gandalf the Grey, Bilbo finds himself joining a company ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 emphasis"
  }, [_c('h2', [_c('strong', [_vm._v("20,7K")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Followers")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success "
  }, [_c('span', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v("  Follow")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 emphasis"
  }, [_c('h2', [_c('strong', [_vm._v("245")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Following")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info "
  }, [_c('span', {
    staticClass: "fa fa-user"
  }), _vm._v("  View Profile")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 emphasis"
  }, [_c('h2', [_c('strong', [_vm._v("43")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Likes")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default"
  }, [_c('span', {
    staticClass: "fa fa-user"
  }), _vm._v("  Likes")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 text-center"
  }, [_c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item text-center"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_c('strong', [_vm._v("Ratings")])]), _vm._v(" "), _c('div', {
    staticClass: "ratings"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa fa-star-o"
  })])])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item text-right"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_c('strong', [_vm._v("Joined")])]), _vm._v("2.13.2014")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item text-right"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_c('strong', [_vm._v("Last seen")])]), _vm._v("Yesterday")]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item text-right"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_c('strong', [_vm._v("Nickname")])]), _vm._v("themesmile")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 profile-name"
  }, [_c('h2', [_vm._v("Dave Mattew\n                                    "), _c('span', {
    staticClass: "pull-right social-profile"
  }, [_c('i', {
    staticClass: "entypo-facebook-circled"
  }), _vm._v(" "), _c('i', {
    staticClass: "entypo-twitter-circled"
  }), _vm._v(" "), _c('i', {
    staticClass: "entypo-linkedin-circled"
  }), _vm._v(" "), _c('i', {
    staticClass: "entypo-github-circled"
  }), _vm._v(" "), _c('i', {
    staticClass: "entypo-gplus-circled"
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('dl', {
    staticClass: "dl-horizontal-profile"
  }, [_c('dt', [_vm._v("User Id")]), _vm._v(" "), _c('dd', [_vm._v("eko.sulis")]), _vm._v(" "), _c('dt', [_vm._v("Name")]), _vm._v(" "), _c('dd', [_vm._v("Eko Sulistyo")]), _vm._v(" "), _c('dt', [_vm._v("Email")]), _vm._v(" "), _c('dd', [_vm._v("eko.sulistyo@yahoo.com")]), _vm._v(" "), _c('dt', [_vm._v("Phone")]), _vm._v(" "), _c('dd', [_vm._v("081 725 xxx")]), _vm._v(" "), _c('dt', [_vm._v("Active Periode")]), _vm._v(" "), _c('dd', [_vm._v("02 Dec 2014")]), _vm._v(" "), _c('dt', [_vm._v("Last Update")]), _vm._v(" "), _c('dd', [_vm._v("02 Apr 2014")]), _vm._v(" "), _c('dt', [_vm._v("About")]), _vm._v(" "), _c('dd', [_vm._v("Web Designer / UI")]), _vm._v(" "), _c('dt', [_vm._v("Hobbies")]), _vm._v(" "), _c('dd', [_vm._v("Read, out with friends, listen to music, draw and learn new things")]), _vm._v(" "), _c('dt', [_vm._v("Skills")]), _vm._v(" "), _c('dd', [_c('span', {
    staticClass: "tags"
  }, [_vm._v("html5")]), _vm._v(" "), _c('span', {
    staticClass: "tags"
  }, [_vm._v("css3")]), _vm._v(" "), _c('span', {
    staticClass: "tags"
  }, [_vm._v("jquery")]), _vm._v(" "), _c('span', {
    staticClass: "tags"
  }, [_vm._v("bootstrap3")])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-170c0892!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/common-page/Profile.vue
// module id = 1270
// module chunks = 2